<template>
  <div class="flex h-screen">
    <main class="w-full overflow-y-auto">
      <RouterView />
    </main>
    <SensorDetails v-if="isSidebarOpen" :sensor="selectedSensor" @close="closeSidebar" :isOpen="isSidebarOpen" />
    <SnackDismissable :messages="getErrors" snack-color="bg-red" :has-error="true" @remove="removeError" />
    <SnackDismissable :messages="getSuccess" snack-color="bg-green-dark" :has-error="false" @remove="removeSuccess" />
  </div>
</template>

<script setup lang="ts">
import SnackDismissable from '@/components/Globals/Feedbacks/SnackDismissable.vue'
import { useErrorStore } from '@/store/error'
import { useSensorStore } from '@/store/sensor'
import { useSuccessStore } from '@/store/success'
import { storeToRefs } from 'pinia'
import { RouterView } from 'vue-router'

const sensorStore = useSensorStore()
const { isSidebarOpen, selectedSensor } = storeToRefs(sensorStore)
const { closeSidebar } = sensorStore

const { getSuccess } = storeToRefs(useSuccessStore())
const { removeSuccess } = useSuccessStore()

const { getErrors } = storeToRefs(useErrorStore())
const { removeError } = useErrorStore()
</script>
